import React, { useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import { TopNav } from '../../views';
import { GoogleAnalytics } from '..';
import { AsideLeft } from '../../views/aside-left';
import AiChatWidget from '../ai-chat/ai-chat-widget';
import PhoneVerifyGate from '../phone-verify/phone-verify-gate';
import AvatarFrameDefs from '../cosmetics/avatar-frame-defs';
import AnnouncementBanner from '../announcement/announcement-banner';
import RewardTicker from '../reward-ticker/reward-ticker';
import { useFeatureFlags } from '../../hooks/useFeatureFlags';
import ScrollToTop from '../route/scroll-to-top.component';

const DefaultLayout = () => {
  // Tên site (admin đổi ở Settings) → tiêu đề tab trình duyệt.
  const { get } = useFeatureFlags();
  useEffect(() => {
    const name = get('site.name').trim();
    if (name) document.title = name;
  }, [get]);

  return (
    <>
      <ScrollToTop />
      <AvatarFrameDefs />
      <AnnouncementBanner />
      <TopNav />
      <div className="fixed top-0 left-0 z-[99] pt-[--m-top] overflow-hidden transition-transform xl:duration-500 max-xl:w-full max-xl:-translate-x-full">
        <AsideLeft />
      </div>
      <main className="2xl:ml-[--w-side]  xl:ml-[--w-side-sm] h-[calc(100vh-var(--m-top))] mt-[--m-top]">
        <Outlet />
      </main>
      <AiChatWidget />
      <PhoneVerifyGate />
      <RewardTicker />
      <GoogleAnalytics />
    </>
  );
};

export default DefaultLayout;
